module.exports = __webpack_public_path__ + "static/media/Kidney Damage.e8f5d8b8.webp";